module.exports = "\r\n<div [id]=\"rootId\"></div>\r\n"